
import { Component, Vue } from "vue-property-decorator";
import axios from "axios";

@Component({
  components: {},
})
export default class HomeView extends Vue {
  URL: string = process.env.VUE_APP_API_ROOT;
  isLoading: boolean = false;
  data: any[] = [];
  yearbefore = null;
  monthbefore = null;
  yearafter = null;
  monthafter = null;

  yearbeforeState = "";
  monthbeforeState = "";
  yearafterState = "";
  monthafterState = "";

  yearbeforeMessage = "";
  monthbeforeMessage = "";
  yearafterMessage = "";
  monthafterMessage = "";

  months: any[] = [];
  months2: any[] = [];

  mounted() {
    this.selectyear1();
  }
  clearFields() {
    this.yearbeforeState = "";
    this.monthbeforeState = "";
    this.yearafterState = "";
    this.monthafterState = "";
    this.yearbeforeMessage = "";
    this.monthbeforeMessage = "";
    this.yearafterMessage = "";
    this.monthafterMessage = "";
  }

  async datos() {
    this.clearFields();
    if (!this.yearbefore) {
      this.yearbeforeState = "is-danger";
      this.yearbeforeMessage = "Campo requerido";
    }
    if (!this.monthbefore) {
      this.monthbeforeState = "is-danger";
      this.monthbeforeMessage = "Campo requerido";
    }

    if (!this.yearafter) {
      this.yearafterState = "is-danger";
      this.yearafterMessage = "Campo requerido";
    }

    if (!this.monthafter) {
      this.monthafterState = "is-danger";
      this.monthafterMessage = "Campo requerido";
    }

    if (
      !this.yearbefore ||
      !this.yearafter ||
      !this.monthbefore ||
      !this.monthafter
    )
      return;

    // this.monthbeforeMessage = "Mes inicio es requerido";
    // this.yearafterMessage = "Fecha fin es requerido";
    // this.monthafterMessage = "Mes fin es requerido";
    this.isLoading = true;
    await axios
      .get(`${this.URL}/api/vivienda/Calculate`, {
        params: {
          yearBefore: this.yearbefore,
          monthBefore: this.monthbefore,
          yearAfter: this.yearafter,
          monthAfter: this.monthafter,
        },
      })
      .then((result) => {
        this.isLoading = false;
        this.data = result.data;
      });
  }
  years: any[] = [];
  years2: any[] = [];

  async selectyear1() {
    await axios.get(`${this.URL}/api/vivienda/GetYears`).then((result) => {
      this.years = result.data;
    });
  }

  async selectMes1() {
    if (!!this.yearbefore) {
      this.yearbeforeState = "";
      this.yearbeforeMessage = "";
    }
    this.monthbefore = null;
    this.yearafter = null;
    this.monthafter = null;
    await axios
      .get(`${this.URL}/api/vivienda/GetMonth1/${this.yearbefore}`)
      .then((result) => {
        this.months = result.data;
      });
  }

  async selectYear2() {
    if (!!this.monthbefore) {
      this.monthbeforeState = "";
      this.monthbeforeMessage = "";
    }
    await axios
      .get(`${this.URL}/api/vivienda/GetYears/${this.yearbefore}`)
      .then((result) => {
        this.years2 = result.data;
      });
  }

  async SelectMes2() {
    if (!!this.yearafter) {
      this.yearafterState = "";
      this.yearafterMessage = "";
    }

    await axios
      .get(`${this.URL}/api/vivienda/GetMonth2/${this.yearafter}`)
      .then((result) => {
        this.months2 = result.data;
      });
  }

  async exportToPDF2() {
    // Definimos el contenido del documento

    await axios
      .get(`${this.URL}/api/vivienda/CreateReport`, {
        params: {
          yearBefore: this.yearbefore,
          monthBefore: this.monthbefore,
          yearAfter: this.yearafter,
          monthAfter: this.monthafter,
        },
      })
      .then((res) => {});
  }

  SelectMes2Validation() {
    if (!!this.monthafter) {
      this.monthafterState = "";
      this.monthafterMessage = "";
    }
  }

  async exportToPDF() {
    this.isLoading = true;
    axios({
      url: `${this.URL}/api/vivienda/ProductsReport`, // File URL Goes Here
      method: "GET",
      responseType: "blob",
      params: {
        yearBefore: this.yearbefore,
        monthBefore: this.monthbefore,
        yearAfter: this.yearafter,
        monthAfter: this.monthafter,
      },
    }).then((res) => {
      this.isLoading = false;
      let blob = new Blob([res.data], { type: "application/pdf" }),
        url = window.URL.createObjectURL(blob);

      window.open(url);
    });
  }
}
